/**
 * @generated SignedSource<<992225f1e0258951dd1d152c9c798724>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelinePageQuery$variables = {
  locator: string;
};
export type PipelinePageQuery$data = {
  readonly pipeline: {
    readonly " $fragmentSpreads": FragmentRefs<"PipelinePageFragment">;
  } | null | undefined;
};
export type PipelinePageQuery = {
  response: PipelinePageQuery$data;
  variables: PipelinePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PipelinePageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelinePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "headBuildType",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalId",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "58b48935bce0e61ea2d2859500d9cb4c",
    "id": null,
    "metadata": {},
    "name": "PipelinePageQuery",
    "operationKind": "query",
    "text": "query PipelinePageQuery(\n  $locator: String!\n) {\n  pipeline(pipelineLocator: $locator) {\n    ...PipelinePageFragment\n    _id\n  }\n}\n\nfragment PipelineContentFragment on BuildTypeRest {\n  ...pipelineHeadBuildTypeFragment\n}\n\nfragment PipelineHeaderFragment on BuildTypeRest {\n  id\n  projectId\n  ...TimeBadgeFragment\n  ...SystemProblemsBadgeFragment\n  ...SaveChangesFragment\n}\n\nfragment PipelinePageFragment on PipelineRest {\n  headBuildType {\n    ...PipelineHeaderFragment\n    ...PipelineContentFragment\n    _id\n  }\n}\n\nfragment SaveChangesFragment on BuildTypeRest {\n  id\n  projectId\n}\n\nfragment SystemProblemsBadgeFragment on BuildTypeRest {\n  projectId\n}\n\nfragment TimeBadgeFragment on BuildTypeRest {\n  internalId\n  id\n}\n\nfragment pipelineHeadBuildTypeFragment on BuildTypeRest {\n  id\n}\n"
  }
};
})();

(node as any).hash = "66ba85e36db4aae34992aed775454b67";

export default node;
